import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withCtx as _withCtx, vShow as _vShow, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ai-meeting-tab-text" }
const _hoisted_2 = { class: "ai-meeting-tab-note" }
const _hoisted_3 = { class: "ai-meeting-body" }
const _hoisted_4 = {
  key: 1,
  class: "ai-meeting-skip"
}
const _hoisted_5 = {
  key: 2,
  class: "ai-meeting-hint"
}
const _hoisted_6 = {
  key: 1,
  class: "ai-meeting-hint ai-meeting-speakers"
}
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 2,
  class: "ai-meeting-hint ai-meeting-hint-line"
}
const _hoisted_9 = {
  key: 3,
  class: "ai-meeting-hint",
  "aria-live": "polite"
}
const _hoisted_10 = {
  key: 4,
  class: "ai-meeting-error",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ai_screen_recorder = _resolveComponent("ai-screen-recorder")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["ai-meeting-recorder", { 'ai-meeting-folded': _ctx.isFolded, 'ai-meeting-idle': !_ctx.jobId && !_ctx.recording }])
  }, [
    (_ctx.isFolded)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "ai-meeting-tab",
          "aria-expanded": "false",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.folded = false))
        }, [
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "ai-meeting-tab-dot" }, null, -1)),
          _createElementVNode("span", _hoisted_1, "Recording · " + _toDisplayString(_ctx.elapsedLabel), 1),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.error ? 'Problem saving' : _ctx.uploading ? 'Saving…' : _ctx.savedChunks ? _ctx.savedChunks + ' chunk' + (_ctx.savedChunks == 1 ? '' : 's') + ' saved' : 'saving each minute'), 1),
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "ai-meeting-tab-open" }, "Open", -1))
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      (_ctx.recording && _ctx.isControlled)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "ai-meeting-fold",
            title: "Fold into a small tab (the recording keeps going)",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.folded = true))
          }, "Fold"))
        : _createCommentVNode("", true),
      (_ctx.canChooseSkip)
        ? (_openBlock(), _createElementBlock("label", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.skip) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.skip]
            ]),
            _cache[7] || (_cache[7] = _createTextVNode("Skip recording", -1))
          ]))
        : _createCommentVNode("", true),
      (_ctx.skipped)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.historyId ? "This meeting isn't being recorded." : !_ctx.canRecord ? "This device can't record meetings, so Start Meeting starts it without a recording. To record it, start the meeting in Chrome or Edge on a computer." : "This meeting won't be recorded. Start Meeting won't ask to share your screen or microphone."), 1))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            (!_ctx.finished || !_ctx.jobId)
              ? (_openBlock(), _createBlock(_component_ai_screen_recorder, {
                  key: 0,
                  ref: "capture",
                  streaming: "",
                  "hide-start": _ctx.controlled && !_ctx.historyId,
                  onRecording: _ctx.recordingChanged,
                  onChunk: _ctx.addChunk,
                  onRecorded: _ctx.stopped
                }, null, 8, ["hide-start", "onRecording", "onChunk", "onRecorded"]))
              : _createCommentVNode("", true),
            (!_ctx.jobId && !_ctx.recording)
              ? (_openBlock(), _createElementBlock("label", _hoisted_6, [
                  _cache[9] || (_cache[9] = _createTextVNode("Speakers ", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.speakerCount) = $event)),
                    "aria-label": "Number of speakers"
                  }, [
                    _cache[8] || (_cache[8] = _createElementVNode("option", { value: null }, "Detect automatically", -1)),
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(30, (n) => {
                      return _createElementVNode("option", {
                        key: n,
                        value: n
                      }, _toDisplayString(n), 9, _hoisted_7)
                    }), 64))
                  ], 512), [
                    [_vModelSelect, _ctx.speakerCount]
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.jobId && !_ctx.recording)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("Start Meeting shares your screen and mic. To include people on the call, pick ", -1),
                  _createElementVNode("strong", null, "Entire Screen", -1),
                  _createTextVNode(" and turn on ", -1),
                  _createElementVNode("strong", null, "Share with system audio", -1),
                  _createTextVNode(".", -1)
                ]))]))
              : _createCommentVNode("", true),
            (_ctx.jobId)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.uploading ? 'Saving recording…' : _ctx.savedChunks ? _ctx.savedChunks + ' recording chunks saved' : 'Recording started — saving each minute'), 1))
              : _createCommentVNode("", true),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.error), 1))
              : _createCommentVNode("", true),
            (_ctx.unfinishedJobId)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 5,
                  to: '/ai-review/' + _ctx.unfinishedJobId
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("Open the unfinished recording", -1)
                  ]))]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (_ctx.error && _ctx.jobId)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 6,
                  class: "ai-btn ai-btn-ghost",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.retry && _ctx.retry(...args)))
                }, "Retry saving"))
              : _createCommentVNode("", true),
            (_ctx.jobId && _ctx.finished && !_ctx.pending.length)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 7,
                  to: '/ai-review/' + _ctx.jobId,
                  class: "ai-btn"
                }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode("Open meeting notes", -1)
                  ]))]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ], 64))
    ], 512), [
      [_vShow, !_ctx.isFolded]
    ])
  ], 2))
}